var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiaochengxu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1667463336831,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1696,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024C229.6832 1024 0 794.3168 0 512S229.6832 0 512 0s512 229.6832 512 512-229.6832 512-512 512z m0-960C265.0112 64 64 265.0112 64 512S265.0112 960 512 960 960 758.9888 960 512 758.9888 64 512 64z",
    "p-id": 1697,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.1104 828.8256c-41.5744 0-82.944-12.8-116.1216-38.912-36.7616-28.9792-58.6752-69.8368-61.7472-114.9952-3.072-46.3872 14.0288-91.3408 48.128-126.464l94.3104-97.28a32.02048 32.02048 0 0 1 45.9776 44.544l-94.3104 97.1776c-21.4016 22.016-32.0512 49.5616-30.208 77.6192 1.7408 26.8288 15.0528 51.3024 37.4784 69.0176 49.664 39.1168 126.7712 32.8704 172.032-13.7216 32.1536-33.1776 46.2848-76.0832 38.8096-117.9648l-32.8704-183.7056c-10.9568-61.2352 9.1136-123.4944 54.8864-170.7008l0.512-0.512c67.4816-69.0176 182.6816-77.6192 257.1264-18.944 36.7616 28.9792 58.7776 69.8368 61.7472 114.9952 3.072 46.3872-14.0288 91.3408-48.128 126.464l-93.3888 96.256a32.02048 32.02048 0 0 1-45.9776-44.544l93.3888-96.256c21.4016-22.016 32.0512-49.5616 30.208-77.6192-1.8432-26.8288-15.1552-51.3024-37.4784-69.0176-49.5616-39.0144-126.7712-32.8704-172.032 13.7216l-0.4096 0.4096c-31.0272 32.256-44.6464 73.9328-37.4784 114.4832l32.8704 183.7056c11.1616 62.3616-9.216 125.6448-55.9104 173.7728-37.376 38.6048-89.6 58.4704-141.4144 58.4704z",
    "p-id": 1698,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiaochengxu);
export default __webpack_public_path__ + "static/media/xiaochengxu.9fa957e4.svg";
export { ForwardRef as ReactComponent };